module.exports = __webpack_public_path__ + "img/3.1fdeda6.svg";